<template>
  <div v-if="hasBrandBillboards" class="billboards-container">
    <div class="dekstop-billboards-container is-hidden-mobile">
      <transition name="fade">
        <template v-if="entity.billboards.length > 1">
          <Tabs :aria-label="entity.name + ' Billboard'" :is-stretched="true">
            <Tab
              v-for="billboard in entity.billboards"
              :key="billboard.id"
              class="tab-container"
              :tab-id="billboard.id"
              :label="getLabel(billboard.title)"
            >
              <template #default="slotProps">
                <Billboard
                  :billboard="billboard"
                  :info-box-description="entity.description"
                  :info-box-title="entity.name"
                  :is-active="slotProps.isActive"
                />
              </template>
            </Tab>
          </Tabs>
        </template>

        <template v-else-if="entity.billboards.length == 1">
          <Billboard
            :billboard="entity.billboards[0]"
            :info-box-description="entity.description"
            :info-box-title="entity.name"
            :is-active="true"
          />
        </template>
      </transition>
    </div>

    <div class="mobile-billboards-container is-hidden-tablet">
      <h3 class="brand-title">
        {{ entity.name }}
      </h3>
      <BrandBillboardCarousel :billboards="mobileOnlyBillboards" />
    </div>
  </div>
</template>

<script>
import Tab from '@sephora-asia/core-tabs/Tab.vue'
import Tabs from '@sephora-asia/core-tabs/Tabs.vue'
import Billboard from './Billboard.vue'
import BrandBillboardCarousel from './BrandBillboardCarousel.vue'

export default {
  name: 'BillboardsContainer',

  components: {
    Billboard,
    BrandBillboardCarousel,
    Tab,
    Tabs
  },

  props: {
    /**
     * An entity containing billboards
     */
    entity: {
      type: Object,
      required: true
    }
  },

  computed: {
    hasBrandBillboards() {
      return this.entity.billboards?.length
    },

    mobileOnlyBillboards() {
      return this.entity.billboards?.filter(
        (billboard) => billboard.isMobileOnly === true
      )
    }
  },
  methods: {
    getLabel(title) {
      return title[`lng-${this.$i18n.locale}`] || title['lng-en'] || title
    }
  }
}
</script>

<style lang="scss" scoped>
.dekstop-billboards-container {
  padding-top: 10px;
  min-height: 300px;
}

.mobile-billboards-container {
  padding-top: 10px;

  .brand-title {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 1px;
    margin-bottom: 10px;
    text-transform: uppercase;
  }
}
</style>
